import React from 'react';
import { Params, useParams } from 'react-router';

export const RouteRender = (props: {
  render: (params: Params) => React.ReactElement;
}) => {
  const params = useParams();
  return props.render(params);
};
